import { isLotTypeCode } from './asset-type-tree'

export interface LotBreakdownPart {
    code: string
    count: number
}

export interface LotBreakdownResult {
    total: number
    parts: LotBreakdownPart[]
}

/** The known subtypes, housing first (the fee basis), then the annexes. */
const FIXED_ORDER = ['unit_housing', 'unit_commercial', 'unit_parking', 'unit_cellar']

function rank(code: string): number {
    const i = FIXED_ORDER.indexOf(code)
    if (i >= 0) return i
    // An organization's own `unit_*` subtype sits after the known ones, the
    // generic `unit` (nature to specify) always last.
    return code === 'unit' ? FIXED_ORDER.length + 1 : FIXED_ORDER.length
}

/**
 * Lots counted by nature (spec 2026-10-11-19): keeps the lot type codes,
 * drops zeros, and orders them in a fixed order, never largest first, so the
 * same line reads the same way on every site.
 */
export function lotBreakdown(counts: Record<string, number> | null | undefined): LotBreakdownResult {
    const parts = Object.entries(counts ?? {})
        .filter(([code, count]) => isLotTypeCode(code) && count > 0)
        .map(([code, count]) => ({ code, count }))
        .sort((a, b) => rank(a.code) - rank(b.code) || a.code.localeCompare(b.code))
    return { total: parts.reduce((sum, p) => sum + p.count, 0), parts }
}
